import { storefrontRequestConfig } from './api'
import axios from 'axios'

/**
 * Get offset of element relative to document.
 * 
 * @param {element} el 
 * @return {Object} The top and left offset of the element relative to the document
 */
export function getElementOffset(el) {
    let top = 0;
    let left = 0;
    let element = el;

    // Loop through the DOM tree
    // and add it's parent's offset to get page offset
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);

    return {
        top,
        left
    };
}

/**
 * Updates the parameter in current URL.
 * 
 * @param {string} name
 * @param {string} value
 */
 export function updateUrlParameter(name, value) {
    let url = new URL(window.location.toString());

    if (!value) {
        url.searchParams.delete(name);
    } else {
        url.searchParams.set(name, value);
    }
    
    window.history.replaceState({path: url.toString()}, '', url.toString());
}

/**
 * Updates the parameter in current URL.
 * 
 * @param {string} name
 */
export function removeParameterFromUrl(name) {
    let url = new URL(window.location.toString());

    url.searchParams.delete(name);
    
    window.history.replaceState({path: url.toString()}, '', url.toString());
}

// /**
//  * Remove the specified parameter from the current URL.
//  * 
//  * @param {string} name  
//  */
// export function removeParameterFromUrl(name) {
//     let url = window.location.href,
//         newUrl = url.split("?")[0],
//         param,
//         params_arr = [],
//         queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";

//     if (queryString !== "") {
//         params_arr = queryString.split("&");
//         for (let i = params_arr.length - 1; i >= 0; i -= 1) {
//             param = params_arr[i].split("=")[0];
//             if (param === name) {
//                 params_arr.splice(i, 1);
//             }
//         }
//         if (params_arr.length) {
//             newUrl = newUrl + "?" + params_arr.join("&");
//         }
//     }
    
//     window.history.replaceState({path: newUrl}, '', newUrl);
// }

export function setContentHeight() {
    const headerElement = document.querySelector('.header-wrapper');
    const headerHeight = headerElement.offsetHeight;
    document.querySelector(':root').style.setProperty('--content-height', window.innerHeight - headerHeight + 'px');
}

export function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function hideElement (el) {
    el.classList.remove('d-block')
    el.classList.add('d-none')
 }
export function showElement (el) {
    el.classList.remove('d-none')
    el.classList.add('d-block')
 }

/**
 * Wrapper for Object.fromEntries to work on older browsers
 */
export const fromEntries = Object.fromEntries||function(e){for(var r,n=("entries"in e?e.entries():e),t={};(r=n.next())&&!r.done;){var i=r.value;Object.defineProperty(t,i[0],{configurable:!0,enumerable:!0,writable:!0,value:i[1]})}return t};

export const getSiblingsGraphQL = async (productInfo) => {
    // eslint-disable-next-line
  let SHOP = Shopify.shop || Shopify.Checkout.apiHost;
  let siblingsQuery = ``
  productInfo.forEach(({id, modelTag}) => {
    siblingsQuery += `
      product${id}: products(first:10, query: "tag:${modelTag}") {
        edges {
          node {
            id
            title
            handle
            tags
          }
        }
      }
    `
  })
  siblingsQuery = `{${siblingsQuery}}`
  const { data: { data } } = await axios.post(`https://${SHOP}/api/2022-10/graphql.json`, siblingsQuery, storefrontRequestConfig)
  let productsResponse = []


  if (data) {
    productsResponse = Object.entries(data).map(([key, value]) => {
      return {
        id: key.replace('product', ''),
        siblings: value.edges?.map(sibling => {
          sibling.node.id = sibling.node.id.replace('gid://shopify/Product/', '')
          return sibling.node
        })
      }
    })
  }
  return productsResponse
}

export const getProductDetails = async (productHandles) => {
  // eslint-disable-next-line
  let SHOP = Shopify.shop || Shopify.Checkout.apiHost;
  let handlesQuery = ``
  productHandles.forEach((handle, index) => {
    handlesQuery += `product${index}: product(handle: ${handle}) {
      title
      handle
      id
      variants(first: 20) {
        edges {
          node {
            availableForSale
            id
            title
          }
        }
      }
      images(first: 10) {
        edges {
          node {
            altText
            src
            originalSrc
          }
        }
      }
    }`
  })
  const query = `{${handlesQuery}}`
  const { data: { data } } = await axios.post(`https://${SHOP}/api/2022-10/graphql.json`, query, storefrontRequestConfig)
  let productDetails = [];
  
  if (data) {
    productDetails = Object.values(data).map(product => {
      if (product) {
        return {
          id: product.id.replace('gid://shopify/Product/', ''),
          handle: product.handle,
          images: product.images.edges.map(image => ({ 
            src: image.node.src, 
            alt: image.node.altText || product.title,
            abs_src: image.node.originalSrc
           })),
          variants: product.variants.edges.map(variant => {
            if (variant) {
              return {
                id: variant.node.id.replace('gid://shopify/ProductVariant/', ''),
                available: variant.node.availableForSale,
                title: variant.node.title
              }
            }
          })
        }
      }
    })
  }

  return productDetails
}

export const getAllCollectionsGraphQL = async () => {
    // eslint-disable-next-line
  const SHOP = Shopify.shop || Shopify.Checkout.apiHost;
  let endCursor = '';
  let hasNextPage = true;
  const collections = [];
  do {
    const afterPart = endCursor ? `, after: "${endCursor}"` : "";
    let collectionsQuery = `
      collections(first: 250${afterPart}) {
        edges {
          node {
            id
            handle
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    `;
    const { data: { data } } = await axios.post(`https://${SHOP}/api/2022-10/graphql.json`, `{${collectionsQuery}}`, storefrontRequestConfig);
    
    if (data && data.collections) {
      data.collections.edges.forEach(edge => {
        collections.push({
          id: edge.node.id.replace('gid://shopify/Collection/', ''),
          handle: edge.node.handle,
        });
      });
      endCursor = data.collections.pageInfo.endCursor;
      hasNextPage = data.collections.pageInfo.hasNextPage;
    } else {
      endCursor = '';
      hasNextPage = false;
    }
  } while (hasNextPage);
  
  return collections;
}

/**
 * Push VTO click event to dataLayer for tracking
 * @param {Object} options - Options for tracking event
 * @param {string} options.glasses_id - ID of the glasses being tried on
 * @param {string} options.cta_location - Location of the CTA (PLP, PDP, etc.)
 */
export function trackVtoClick(options = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'vto_clicks',
    cta_id: options.glasses_id || null,
    cta_text: 'VR TRY ON',
    cta_location: options.cta_location || '',
    timestamp: new Date().toISOString()
  });
}
